module.exports = __webpack_public_path__ + "img/social_recruitment.56527f3.png";